import { z } from "zod";
import { defineMutation } from "supabase/database/server.ts";

export const addBookmark = defineMutation({
  input: z.object({
    table_name: z.string(),
    content_id: z.string(),
    content_title: z.string().optional(),
    page_number: z.number().int().optional(),
    label: z.string().optional(),
    content_path: z.string().optional(),
  }),
  handler: async ({ db }, data) => {
    const { data: { user } } = await db.auth.getUser();
    if (!user) throw new Error("Not authenticated");
    const { data: result, error } = await db
      .from("bookmarks")
      .insert({ ...data, user_id: user.id })
      .select()
      .single();
    if (error) throw error;
    return result;
  },
});

export const removeBookmark = defineMutation({
  input: z.object({ id: z.number() }),
  handler: async ({ db }, { id }) => {
    const { error } = await db.from("bookmarks").delete().eq("id", id);
    if (error) throw error;
  },
});
